import {
  AtlasBodyMain,
  AtlasCaption,
  AtlasColor,
  CardComponent,
  IconButtonMolecule,
  TagMolecule
} from '@justomx/atlas-components'
import { Icon } from '@justomx/atlas-icons'

import { StackAtom } from 'components/atoms/Stack.atom'
import type { PreparationPalletData } from 'types/assembly/model'

interface PreparationPalletCardOrganismProps {
  palletNumber: number
  totalPallets: number
  palletData: PreparationPalletData
  onPrint?: (palletData: PreparationPalletData, palletNumber: number) => void
}

export const PreparationPalletCardOrganism = (
  props: PreparationPalletCardOrganismProps
) => {
  const { palletNumber, totalPallets, palletData, onPrint } = props
  const {
    container,
    productCount,
    currentPallet,
    palletScanned,
    palletReady,
    location
  } = palletData

  const highlightContainer = currentPallet && !palletScanned

  return (
    <CardComponent style={{ padding: '12px' }}>
      <StackAtom $direction="column" $gap={16}>
        <StackAtom $justify="space-between">
          <StackAtom $direction="column" $gap={4}>
            <AtlasCaption style={{ fontWeight: 700, color: '#C2C2C2' }}>
              {`Tarima ${palletNumber} de ${totalPallets}`}
            </AtlasCaption>

            <StackAtom $gap={16} $align="center">
              <AtlasBodyMain style={{ fontWeight: 700 }}>
                {container}
              </AtlasBodyMain>

              <TagMolecule
                text={`${productCount}`}
                icon={<Icon name="ic_product" color="white" size={18} />}
              />
            </StackAtom>
          </StackAtom>

          <IconButtonMolecule
            type="button"
            secondary
            iconName="ic_print"
            style={{ borderRadius: '100px', width: '40px', height: '40px' }}
            onClick={(event) => {
              event.currentTarget.blur()
              onPrint?.(palletData, palletNumber)
            }}
          />
        </StackAtom>

        <StackAtom $justify="space-between" $align="center">
          <StackAtom $gap={8} $align="center">
            <TagMolecule
              style={{ padding: '8px' }}
              bgColor={
                palletReady
                  ? '#292929'
                  : highlightContainer
                    ? '#3C2E02'
                    : undefined
              }
              textColor={
                palletReady
                  ? '#5C5C5C'
                  : highlightContainer
                    ? '#FDF0C3'
                    : undefined
              }
              text="Etiqueta"
              icon={
                <Icon
                  name="ic_scan_qr"
                  color={palletReady ? AtlasColor.BackgroundTap : '#E0E0E0'}
                  size={18}
                />
              }
            />

            <Icon
              name="arrow"
              color={palletReady ? AtlasColor.BackgroundTap : '#E0E0E0'}
              size={18}
            />

            <TagMolecule
              style={{ padding: '8px', width: '140px' }}
              text={location}
              bgColor={
                palletReady ? '#292929' : palletScanned ? '#3C2E02' : undefined
              }
              textColor={
                palletReady ? '#5C5C5C' : palletScanned ? '#FDF0C3' : undefined
              }
            />
          </StackAtom>
          <Icon
            name={palletReady ? 'ic_check_circle_fill' : 'ic_check_circle_dark'}
            color={palletReady ? '#21C043' : '#7A7A7A'}
            size={24}
          />
        </StackAtom>
      </StackAtom>
    </CardComponent>
  )
}
